(function () {
  'use strict';

  if (window.__PGCountryProtectionV60) return;
  window.__PGCountryProtectionV60 = true;

  var config = window.PGCountryProtectionV60 || {};
  var params = new URLSearchParams(window.location.search);

  if ((window.Shopify && window.Shopify.designMode) || config.designMode) return;

  var blocked = String(config.blockedCountriesCsv || '')
    .split(',')
    .map(function (code) { return code.trim().toUpperCase(); })
    .filter(Boolean);

  function normalizeCountry(value) {
    return String(value || '').trim().toUpperCase();
  }

  function canUseQaOverride() {
    return String(config.themeRole || '').toLowerCase() === 'unpublished';
  }

  function shouldBlock(country) {
    return Boolean(country && blocked.indexOf(country) !== -1);
  }

  function renderBlock(country) {
    if (!document.body || document.getElementById('pg-country-protection-v60')) return;

    document.documentElement.classList.add('pg-country-protection-active');
    document.body.classList.add('pg-country-protection-active');

    var overlay = document.createElement('div');
    overlay.id = 'pg-country-protection-v60';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'pg-country-protection-title');
    overlay.setAttribute('data-detected-country', country || 'unknown');

    var card = document.createElement('div');
    card.className = 'pg-country-protection-v60__card';

    var eyebrow = document.createElement('p');
    eyebrow.className = 'pg-country-protection-v60__eyebrow';
    eyebrow.textContent = 'Paw & Glory';

    var title = document.createElement('h1');
    title.id = 'pg-country-protection-title';
    title.textContent = 'This store is not available in your region';

    var copy = document.createElement('p');
    copy.className = 'pg-country-protection-v60__copy';
    copy.textContent = 'We are unable to offer access or accept orders from your current location.';

    var support = document.createElement('p');
    support.className = 'pg-country-protection-v60__support';
    support.innerHTML = 'Think this is a mistake? <a href="mailto:support@pawandglory.com">Contact Paw & Glory support</a>.';

    card.appendChild(eyebrow);
    card.appendChild(title);
    card.appendChild(copy);
    card.appendChild(support);
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    title.setAttribute('tabindex', '-1');
    try {
      title.focus({ preventScroll: true });
    } catch (error) {
      title.focus();
    }
  }

  function applyCountry(country) {
    country = normalizeCountry(country);

    if (canUseQaOverride() && params.get('pg_country_test')) {
      country = normalizeCountry(params.get('pg_country_test'));
    }

    if (!shouldBlock(country)) return;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { renderBlock(country); }, { once: true });
    } else {
      renderBlock(country);
    }
  }

  function detectCountry() {
    var fallbackCountry = normalizeCountry(config.country);
    var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;

    if (shouldBlock(fallbackCountry)) {
      applyCountry(fallbackCountry);
      return;
    }

    if (!routesRoot || typeof window.fetch !== 'function') {
      applyCountry(fallbackCountry);
      return;
    }

    var url = routesRoot + 'browsing_context_suggestions.json?country[enabled]=true';

    fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('country detection unavailable');
        return response.json();
      })
      .then(function (data) {
        var detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        applyCountry(detected || fallbackCountry);
      })
      .catch(function () {
        applyCountry(fallbackCountry);
      });
  }

  detectCountry();
})();
